export default __webpack_public_path__ + "static/media/stsweep-og.861bc5f0.jpg";